<div class="bg-ponder-dark min-h-screen w-full overflow-x-hidden flex flex-col"  style="background: linear-gradient(#343346, #1A1922);">
    <div class="flex flex-col gap-4 p-8 pt-12 pb-12 justify-center text-faded-80">
        <div class="flex justify-center items-center">
            <svg class="w-32 h-32 fill-none stroke-faded-90 group-hover:stroke-faded-90" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="0.75">
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="envelopeIconSvg" />
            </svg>  
        </div>
        <div class="text-center text-lg font-bold">
            Check your email
        </div>
        <div class="text-center text-sm">
            <br/>
            If the provided email address is associated with an account then a one-time password reset link will be delivered to it.
            <br/>
        </div>
    </div>
</div>